import React from 'react';

const Image = {
  sizes: [1920, 1600, 1366, 1024, 768, 640, 320],
  url: function (
    image,
    height,
    width,
    transforms,
    defaultUrl,
    backgroundColor
  ) {
    if (!image || !image.S3Id || image.S3Id.length == 0) {
      return defaultUrl;
    }

    const queryParams = [];
    if (image.Extension != 'svg' && image.Extension != 'gif') {
      if (width != undefined) {
        queryParams.push(`w_${width}`);
      }
      if (height != undefined) {
        queryParams.push(`h_${height}`);
      }
      let _transforms = transforms;
      if (queryParams.length > 0 && (!_transforms || _transforms.length == 0)) {
        queryParams.push('c_fit');
      }
      if (
        _transforms == 'c_pad' &&
        backgroundColor &&
        backgroundColor.length > 0
      ) {
        _transforms = `c_pad,b_${backgroundColor}`;
      }
      if (_transforms && _transforms.length > 0) {
        queryParams.push(_transforms);
      }
    }
    let joinedParams = queryParams.join(',');
    if (queryParams.length > 0) {
      joinedParams += `/${image.S3Id}`;
    } else {
      joinedParams += image.S3Id;
    }

    const cdnUrl = 'https://cdn.artcld.com/img/';
    return `${cdnUrl}${joinedParams}.${image.Extension}`;
  },
};

function ImageSrcSet(props) {
  let dataSrc,
    dataSrcSet,
    src,
    cols = parseInt(props.cols),
    sizes = '1920px';
  if (props.imageTuples) {
    const index = props.index || props.imageTuples.length - 1;
    dataSrcSet = props.imageTuples.map(function (d, i) {
      if (i == index) {
        dataSrc = d.url;
        src = dataSrc;
      }
      sizes += `,(max-width: ${d.size}px) ${d.size / cols}px`;
      return `${d.url} ${d.size}w`;
    });
  }
  const _data = props.data || {};
  const style = props.style || {};
  const handleOnLoad = props.handleOnLoad || undefined;
  let _className = '';
  if (props.className && props.className.length > 0) {
    _className += ` ${props.className}`;
  }
  return (
    <img
      className={_className}
      srcSet={dataSrcSet.join(', ')}
      sizes={`(max-width: 767px) 100vw, ${100/cols+1}vw`}
      src={src}
      onLoad={handleOnLoad}
      style={style}
      {..._data}
    />
  );
}

class LinkedImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      containerWidth: undefined,
    };

    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  componentDidMount() {
    if (this.props.containerRef) {
      this.setState({
        containerWidth: this.props.containerRef().clientWidth,
      });
    }
  }

  handleImageLoad(event) {
    const target = event.currentTarget;
    const parent = this.props.link
      ? target.parentNode.parentNode
      : target.parentNode;
    target.style.position = this.props.targetPosition || 'static';
    target.style.visibility = 'visible';
    target.style.opacity = 1;
    if (parent.children.length < 2) {
      return;
    }
    target.parentNode.style.width = this.props.width ? this.props.width + 'px' : '100%';
    const temp = parent.children[1];
    temp.remove();
  }

  render() {
    const props = this.props;
    const state = this.state;

    let altImageTuples;
    let aspectRatio;
    let originalAspectRatio;
    let imageWidth;
    let imageHeight;
    let imageStyle = {};
    let placeholderStyle = {};
    let containerStyle = {};
    let linkStyle = {};


    var display = 'flex';
    // NOTE: Defaults to square
    if (props.type === 'fill' || props.type === 'pad') {
      const gutter = props.gutter || 16.67;
      const containerWidth = props.containerRef
        ? state.containerWidth
        : document.body.clientWidth;

      if (props.cols && containerWidth) {
        const desktopContainerWidth = props.containerRef
          ? containerWidth
          : containerWidth - 66.67 > 1200
          ? 1200
          : containerWidth - 66.67;
        if (window.innerWidth > 766) {
          imageWidth = props.slider
            ? (desktopContainerWidth - gutter * (props.cols - 1)) / props.cols
            : desktopContainerWidth / props.cols - gutter;
        } else if (window.innerWidth > 581) {
          imageWidth = containerWidth - 66.67;
        } else {
          imageWidth = containerWidth - 50;
        }
      } else {
        imageWidth = 250;
      }
      imageHeight = imageWidth;
    }
    // NOTE: Respects aspect ratio
    else {
      if (props.image) {
        originalAspectRatio = props.image.Width / props.image.Height;
        if (props.height) {
          imageWidth = props.height * originalAspectRatio;
        } else if (props.width) {
          imageHeight = props.width / originalAspectRatio;
        } else {
          imageWidth = props.image.Width;
          imageHeight = props.image.Height;
        }
      } else {
        imageWidth = '100%';
        imageHeight = 'auto';
      }
    }
    imageWidth = props.width || imageWidth;
    imageHeight = props.height || imageHeight;
    aspectRatio = imageWidth / imageHeight;

    imageStyle = {
      top: 0,
      left: 0,
      opacity: 0,
      width:
        (props.type === 'pad' && props.image.Extension !== 'gif') ||
        props.type === 'fit'
          ? 'auto'
          : '100%',
      height: 'auto',
      maxHeight: '100%',
      maxWidth: '100%',
      visibility: 'hidden',
      position: 'absolute',
      transition: 'all 0.5s ease-in-out',
      WebkitTransition: 'all 0.5s ease-in-out',
    };
    
    containerStyle = {
      height: imageHeight,
      width: props.width && (props.type === 'fill' || props.type === 'pad') ? props.width : '100%',
      overflow: 'hidden',
      display: display,
      alignItems: 'center',
      justifyContent: 'center',
    };
    
    linkStyle = {
      display:
        props.type === 'pad' || props.type === 'fit' ? 'flex' : 'block',
      alignItems: 'center',
      justifyContent: 'center',
      height: props.type === 'pad' ? '100%' : 'auto',
    };

    if (props.image) {
      placeholderStyle = {
        backgroundColor: `rgb(${props.image.PrimaryR},${props.image.PrimaryG},${props.image.PrimaryB})`,
        height: imageHeight,
        width: imageWidth,
      };

      let type;
      if (props.type === 'fill') {
        type = 'c_fill';
      } else if (props.type === 'pad') {
        type = 'c_pad';
      } else {
        type = 'c_fit';
      }

      altImageTuples = Image.sizes.map(function (d) {
        return {
          size: d,
          url: Image.url(props.image, d, d, type),
        };
      });
    }

    return (
      <div>
        {props.image ? (
          props.link ? (
            <div style={containerStyle}>
              <a href={props.link} style={linkStyle}>
                <ImageSrcSet
                  className={props.imageClass}
                  data={{ alt: props.alt, title: props.title }}
                  style={imageStyle}
                  handleOnLoad={this.handleImageLoad}
                  imageTuples={altImageTuples}
                  index={props.index}
                  cols={props.cols}
                  aria-label={props.alt}
                />
              </a>
              <div
                style={placeholderStyle}
                className={props.placeholderClass}
              />
            </div>
          ) : (
            <div>
              <div style={containerStyle}>
                <ImageSrcSet
                  className={props.imageClass}
                  data={{ alt: props.alt, title: props.title }}
                  style={imageStyle}
                  handleOnLoad={this.handleImageLoad}
                  imageTuples={altImageTuples}
                  index={props.index}
                  cols={props.cols}
                />
                <div
                  style={placeholderStyle}
                  className={props.placeholderClass}
                />
              </div>
            </div>
          )
        ) : props.noImage ? (
          <div style={containerStyle}>
            { props.link ? (
                <a href={props.link} style={{
                  ...linkStyle,
                  height: '100%',
                  width: '100%'
                }}>
                { props.noImage }
              </a>
            ) : props.noImaage }  
          </div>
          ) : (
           <div />
          )
        }
      </div>
    );
  }
}

export default Image;
export { LinkedImage, ImageSrcSet };
